import { triggerEvent } from "./trigger-event";

window.HTMLFormElement.prototype.clear = function() {
    for (let field in this.elements) {
        let element = this.elements[field];
        if (!(element instanceof HTMLElement)) continue;

        if (element.type == "button" || element.type == "submit") continue;
        if (element.type == "radio" || element.type == "checkbox") {
            console.log(element, element.hasAttribute('data-reset-value'))
            element.checked = element.hasAttribute('data-reset-value');
            continue;
        }
        if (element instanceof HTMLSelectElement) {
            element.value = element.options[0]?.value;
            continue;
        }
        
        element.value = "";
    }
    triggerEvent(this, "clear");
}